export function router_matcbh(pathname) {

    if (pathname.match(/^\/$/)) return "home"
    if (pathname.match(/^\/campaign/)) return "campaign"

    if (pathname.match(/^\/brand\//)) return "brand"
    if (pathname.match(/^\/brand\/$/)) return "brand"

    if (pathname.match(/^\/hot/)) return "hot"
    if (pathname.match(/^\/search/)) return "search"

    if (pathname.match(/^\/product/)) return "product"

    if (pathname.match(/^\/category/)) return "category"

    return "other"
}
export function router_matcbh_v2(pathname) {

    if (pathname.match(/^\/$/)) return "home"
    if (pathname.match(/^\/exclusive/)) return "List"
    if (pathname.match(/^\/function/)) return "List"
    if (pathname.match(/^\/gift_set/)) return "List"

    if (pathname.match(/^\/campaign/)) return "Campaign"
    if (pathname.match(/^\/weeklyspecials/)) return "Campaign"
    if (pathname.match(/^\/brand\//)) return "List"
    if (pathname.match(/^\/brand\/story$/)) return "Campaign"

    if (pathname.match(/^\/hot/)) return "Search"
    if (pathname.match(/^\/search/)) return "Search"
    if (pathname.match(/^\/myAccount/)) return "Function"

    if (pathname.match(/^\/product/)) return "product"

    if (pathname.match(/^\/category/)) return "List"

    return "other"
}
export function router_matcbh_v3(url) {
    const a = url.indexOf('/');
    const b = url.indexOf('?');
    const pathname = url.slice(a,b)
    if (pathname.search(/\/exclusive/)> 0) return "List"
    if (pathname.search(/\/function/)> 0) return "List"
    if (pathname.search(/\/gift_set/)> 0) return "List"

    if (pathname.search(/\/campaign/)> 0) return "Campaign"
    if (pathname.search(/\/weeklyspecials/)> 0) return "Campaign"
    if (pathname.search(/\/rank/)> 0) return "Campaign"

    if (pathname.search(/\/brand\//)> 0) return "List"
    if (pathname.search(/\/brand\/story$/)> 0) return "Campaign"

    if (pathname.search(/\/hot/)> 0) return "Search"
    if (pathname.search(/\/search/)> 0) return "Search"

    if (pathname.search(/\/product/)> 0) return "product"

    if (pathname.search(/\/category/)> 0) return "List"
    if (pathname.search(/\/myAccount/)> 0) return "Function"


    return "other"
}


// WEBPACK FOOTER //
// ./common/Mapping/router.js